var e=function _taggedTemplateLiteral(e,t){return t||(t=e.slice(0)),Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}))};export default e;
//# sourceMappingURL=taggedTemplateLiteral.js.map
